import React from 'react'

const LoadingIndicator = (): JSX.Element | null => {
  return <div className="p-10">Loading...</div>
}

export default LoadingIndicator
